import { UsuariosService } from './usuarios.service';
import { User } from 'src/app/model/user.model';
import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService
{

  constructor(
    private service: UsuariosService,
  ) { }

  public success(message?: string, title?: string): void
  {
    this.showAlert(title!, message!, 'success');
  }

  public error(message?: string, title?: string): void
  {
    this.showAlert(title!, message!, 'error');
  }

  private showAlert(title: string, message: string, icon: SweetAlertIcon): void
  {
    Swal.fire(title, message, icon);
  }

  public info(message?: string, title?: string): void
  {
    this.showAlert(title!, message!, 'info');
  }

  public warning(message?: string, title?: string): void
  {
    this.showAlert(title!, message!, 'warning');
  }

  public loading(message: string): void
  {
    Swal.fire({
      title: message,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () =>
      {
        Swal.showLoading();
      },
    });
  }

  public dismiss(): void
  {
    Swal.close();
  }

  public updateLoadingMessage(message: string)
  {
    Swal.update({
      title: message,
      allowOutsideClick: false,
    });
    Swal.showLoading();
  }

  public exibirMensagemErro(erro: any, mensagem?: string): void
  {
    if (erro.status === 503 && erro.error.mensagem === 'Serviço indisponível devido à manutenção programada.') {
      this.programmedBackupMessage();
    } else {
      this.warning(mensagem || erro.error.mensagem || erro.error.status);
    }
  }

  public programmedBackupMessage(): void
  {
    Swal.fire({
      title: `<h1> Ops! </h1><h3 class='m-0'> Estamos passando por uma manutenção programada, que acontece todos os dias da 01h55 às 03h30 (no horário de Brasília).
                <b>Apenas</b> os seguintes recursos ficam indisponíveis durante esse período:
                - Cadastro, edição e exclusão de comunicadores</h3>`,
      imageUrl: '/assets/engrenagens.png',
      imageWidth: '18vh',
      imageHeight: '18vh',
    });
  }
}
